import FormDialog from "../../../components/dialog/form/FormDialog.vue";
import SelectField from "../../../components/fields/selectField/SelectField.vue";
import TextField from "../../../components/fields/textField/TextField.vue";
//import { MapeamentoFeriasService } from "../../services/MapeamentoFeriasService";

export default {
  name: "VisaoGeral",

  components: {
    FormDialog,
    SelectField,
    TextField,
  },
  props: {
    metricas: []
  },

  data: () => ({
    data: [],
    meses: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    nomeMeses: {
      Dec: "Dezembro",
      Nov: "Novembro",
      Oct: "Outubro",
      Sep: "Setembro",
      Aug: "Agosto",
      Jul: "Julho",
      Jun: "Junho",
      May: "Maio",
      Apr: "Abril",
      Mar: "Março",
      Feb: "Fevereiro",
      Jan: "Janeiro"
    },
    show: false,

  }),


  beforeMount() {},

  methods: {



  },
};